import React from 'react';
import PageContainer from '../../../../@jumbo/components/PageComponents/layouts/PageContainer';

import SolvedOcurrences from '../../../../f5/ocurrences/SolvedOcurrences';
import OcurrenceNavbar from '../../../../f5/ocurrences/SharedComponents/OcurrenceNavbar';

const Solved = () => {
  return (
    <PageContainer>
      <OcurrenceNavbar />
      <SolvedOcurrences />
    </PageContainer>
  );
};

export default Solved;
